import BaseService from './BaseServices';
import { AuthUrls } from './urls';

class AuthService {
    static login = (info) => {
        return BaseService.postRequest(AuthUrls.LOGIN_USER, info, false)
    };

    static add_new_user = (data) => {
        return BaseService.postRequest(AuthUrls.ADD_NEW_USER, data, true);
    };

    static get_all_users = (params = {}) => {
        const query = new URLSearchParams(params).toString();
        const url = query ? `${AuthUrls.READ_ALL_USERS}?${query}` : AuthUrls.READ_ALL_USERS;
        return BaseService.getRequest(url, true);
    };

    static update_password = (data) => {
        return BaseService.putRequest(AuthUrls.UPDATE_PASSWORD, data, true);
    };

    static check_token = (data) => {
        return BaseService.postRequest(AuthUrls.CHECK_TOKEN, data, false)
    }

    static get_default_data = () => {
        return BaseService.getRequest(AuthUrls.DEFAULT_DATA, false)
    }

    static get_stats = () => {
        return BaseService.getRequest(AuthUrls.STATS, true)
    }

    static get_all_licenses = (params = {}) => {
        const query = new URLSearchParams(params).toString();
        const url = query ? `${AuthUrls.READ_ALL_LICENSES}?${query}` : AuthUrls.READ_ALL_LICENSES;
        return BaseService.getRequest(url, true)
    }

    static add_new_license = (data) => {
        return BaseService.postRequest(AuthUrls.GENERATE_NEW_LICENSE, data, false)
    }

    static delete_license = (params = {}) => {
        const query = new URLSearchParams(params).toString();
        const url = query ? `${AuthUrls.DELETE_LICENSE}?${query}` : AuthUrls.DELETE_LICENSE;
        return BaseService.deleteRequest(url ,true)
    }

    static update_license = (data) => {
        return BaseService.putRequest(AuthUrls.UPDATE_LICENSE, data, true)
    }

    static delete_user = (params = {}) => {
        const query = new URLSearchParams(params).toString();
        const url = query ? `${AuthUrls.DELETE_USER}?${query}` : AuthUrls.DELETE_USER;
        return BaseService.deleteRequest(url ,true);
    }

    static update_user = (data) => {
        return BaseService.putRequest(AuthUrls.UPDATE_USER, data, true)
    }

    static license_usage_data = (params = {}) => {
        const query = new URLSearchParams(params).toString();
        const url = query ? `${AuthUrls.LICENSE_USAGE_DATA}?${query}` : AuthUrls.LICENSE_USAGE_DATA;
        return BaseService.getRequest(url, true)
    }
    
    static auth_me = (data) => {
        return BaseService.postRequest(AuthUrls.AUTH_ME, data, true)
    }

    static get_latest_version = () => {
        return BaseService.getRequest(AuthUrls.LATEST_VERSION, false)
    }

    static upload_new_file = (data) => {
        return BaseService.postRequest(AuthUrls.UPLOAD_NEW_VERSION, data, false)
    }
}

export default AuthService;